// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__1hDph","modalHeader":"modal_modalHeader__O5Gi0","modalHeading":"modal_modalHeading__2VpdL","modalContainer":"modal_modalContainer__3cY2T"};